import Vue from 'vue'
import Vuex from 'vuex'

import pages from './pages'
import galerija from './galerija'
import slider from './slider'
import materijali from './materijali'
import menu from './menu'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    pages,
    galerija,
    slider,
    materijali,
    menu
  }
})

export default store
